module.exports = __webpack_public_path__ + "static/media/report-button-trim-max.62a5dbaf.svg";